<div class="ui-g">
    <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
      <p-panel header="{{ 'prepaid' | translate }}" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px'}">
        <app-prepaid-total *ngIf="currencySymbol" [currencySymbol]="currencySymbol"></app-prepaid-total>

        <mat-accordion multi="true">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="title">
                {{ 'prepaid_standard' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <p-panel *ngIf="showSummary == false" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px'}">
              <form [formGroup]="prepaidForm" (ngSubmit)="gotoSummary()">
                <div class="ui-g">
                    <div class="ui-g-12 hide-arrows">
                        <p>{{ 'prepaid_amount' | translate }}</p>
                        <input formControlName="prepaidAmount" type="number" pInputText min="0.00" step="0.01" style="text-align: center; display: inline-block;">
                        <h4 style="display: inline-block; margin-left: 10px;">{{ currencySymbol }}</h4>
                    </div>
                </div>
                <hr>

                <div class="ui-g">
                  <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                    <invoice-details-list [readonly]="false" (onChangeInvoice)="changeInvoice($event)"></invoice-details-list>
                  </div>

                  <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                    <div class="ui-g nuty-bg">
                         <div class="ui-sm-12 ui-md-6 ui-lg-6 ui-xl-6">
                       <div class="ui-g-12">
                          <h4>{{ 'payment_type' | translate }}</h4>
                        </div>
                        <div class="ui-g-12">
                          <app-payment-type [prepaidMode]="true" (changePaymentMethod)="onSelectPaymentMethod($event)"></app-payment-type>
                        </div>
                      </div>
                      <div class="ui-sm-12 ui-md-6 ui-lg-6 ui-xl-6">
                        <div class="ui-g-12" style="padding: 20px;">
                          
                          <h2 *ngIf="prepaidForm.get('prepaidAmount').value != ''" style="float: right;">{{ prepaidForm.get('prepaidAmount').value | currency:selectedCurrency }}</h2>
                          <h2 *ngIf="prepaidForm.get('prepaidAmount').value == '' || prepaidForm.get('prepaidAmount').value == null" style="float: right;">{{ 0 | currency:selectedCurrency }}</h2>
                          <h2 style="float: right; margin-right: 8px; font-weight: normal;">{{ 'total' | translate }}</h2>
                        </div>
                        <div class="ui-g-12" style="padding: 20px;">
                            <button [disabled]="!prepaidForm.valid"type="submit" style="width: 100%; min-height: 40px;" pButton label=" {{ 'go_to_summary' | translate }}"></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </p-panel>

            <p-panel *ngIf="showSummary == true" header="{{ 'prepaid_summary' | translate }}" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px'}">
                <div class="ui-g">
                    <div class="ui-g-12">
                        <p style="margin-bottom: 0px;">{{ 'prepaid_amount' | translate }}: <span style="font-size: 20px; font-weight: bold;">{{ prepaidForm.controls['prepaidAmount'].value | currency:selectedCurrency }} </span></p>
                        </div>
                        <div class="ui-g-12">
                        <p style="margin-top: 0px;">{{ 'payment_type' | translate }}:
                            <span *ngIf="prepaidForm.controls['payment_type'].value == 'payu'" style="font-size: 16px; font-weight: bold;"> PAYU </span>
                            <span *ngIf="prepaidForm.controls['payment_type'].value == 'paypal'" style="font-size: 16px; font-weight: bold;"> PAYPAL </span>
                        </p>
                    </div>
                </div>
                <div class="ui-g">
                    <div class="ui-g-12">
                        <h4>{{ 'invoice_details' | translate }}:  </h4>
                        <p>
                            <span *ngIf="invoiceSelected.invoiceType === 2">{{ 'name_and_surname' | translate }} </span>
                            <span *ngIf="invoiceSelected.invoiceType === 1">{{ 'company_name' | translate }} </span>
                            {{ invoiceSelected.name }}
                        </p>
                        <p> {{ 'address' | translate }}
                        {{ invoiceSelected.country }}
                        ,
                        {{ invoiceSelected.postal_code }} {{ invoiceSelected.city }}
                        ,
                        {{ invoiceSelected.street }} {{ invoiceSelected.street_number }}
                        <span *ngIf="invoiceSelected.apartment_number != ''">/{{ invoiceSelected.apartment_number }}</span>
                        </p>
                        <p *ngIf="invoiceSelected.invoiceType === 1">{{ 'tax_number' | translate }} {{ invoiceSelected.tax_number }}</p>
                    </div>
                </div>

                <hr>
                <div class="ui-g">
                    <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-4">
                        <div class="ui-g nuty-bg">
                            <div class="ui-g-12" style="padding: 20px;">
                                <button type="submit" (click)="onGoBack()" style="width: 100%; min-height: 40px;" pButton label="{{ 'back_btn' | translate }}"></button>
                            </div>
                        </div>
                    </div>
                    <div class="ui-sm-0 ui-md-0 ui-lg-4 ui-xl-4">
                    </div>
                    <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-4">
                        <div class="ui-g nuty-bg">
                            <div class="ui-g-12" style="padding: 20px;">
                                <button (click)="onOrderAndPay()"type="submit" style="width: 100%; min-height: 40px;" pButton label="{{ 'order_and_pay' | translate }}"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </p-panel>

          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="title">
                {{ 'prepaid_by_code' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <p-panel [toggleable]="false" [collapsed]="false" >
              <app-prepaid-by-code></app-prepaid-by-code>
            </p-panel>

          </mat-expansion-panel>
        </mat-accordion>
      </p-panel>
    </div>

</div>

